import { Action, createReducer, on } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import {
    addEscalationTimerEntry,
    clearEscalationTimerEntries,
    escalationTimersLoadedFromStorage,
    removeEscalationTimerEntry,
} from '../actions/escalation.actions';
import {
    EscalationCollectionState,
    EscalationTimer,
    initialEscalationCollectionState,
} from '../escalation-collection.state';
import { NotificationStateUtilities } from '../../utilities/notification-state-utlities';
import { NotificationIdState } from '../../utilities/notification-id.type';

const addTimerEntryReducer = (
    state: Readonly<EscalationCollectionState>,
    { notificationId, timerHandle }: { notificationId: NotificationIdState; timerHandle: number },
): Readonly<EscalationCollectionState> => ({
    ...state,
    timerEntries: [...state.timerEntries, { notificationId, timerHandle }],
});

const removeTimerEntryReducer = (
    state: Readonly<EscalationCollectionState>,
    { notificationId }: { notificationId: NotificationIdState },
): Readonly<EscalationCollectionState> => ({
    ...state,
    timerEntries: state.timerEntries.filter(
        (entry) => !NotificationStateUtilities.compare(entry.notificationId, notificationId),
    ),
});

const clearTimerEntriesReducer = (state: Readonly<EscalationCollectionState>): Readonly<EscalationCollectionState> => ({
    ...state,
    timerEntries: [],
});

const loadFromStorageReducer = (
    state: Readonly<EscalationCollectionState>,
    { timerEntries }: { timerEntries: EscalationTimer[] },
): Readonly<EscalationCollectionState> => ({
    ...state,
    timerEntries,
    status: LoadStatus.Loaded,
});

const createEscalationReducer = createReducer(
    initialEscalationCollectionState,
    on(addEscalationTimerEntry, addTimerEntryReducer),
    on(removeEscalationTimerEntry, removeTimerEntryReducer),
    on(clearEscalationTimerEntries, clearTimerEntriesReducer),
    on(escalationTimersLoadedFromStorage, loadFromStorageReducer),
);

export function escalationReducer(
    state: Readonly<EscalationCollectionState> | undefined,
    action: Action,
): Readonly<EscalationCollectionState> {
    return createEscalationReducer(state, action);
}
